import { FilterState } from '@/fsd/shared/ui/filter-panel/types';

const processFilterValue = (value: any) => {
  if (Array.isArray(value) && value.length > 0) {
    return value.map(Number);
  }
  if (value) {
    return [Number(value)];
  }
  return undefined;
};

export const sanitizeMutualSettlementsFilters = (
  activeFilters: FilterState
) => {
  const cleanedFilters = { ...activeFilters };

  Object.keys(cleanedFilters).forEach((key) => {
    const value = cleanedFilters[key as keyof FilterState];
    if (typeof value === 'string' && value.trim() === '') {
      delete cleanedFilters[key as keyof FilterState];
    }
  });

  const requestFilters: any = {};

  if (cleanedFilters.date) {
    requestFilters.date_from = Array.isArray(cleanedFilters.date)
      ? cleanedFilters.date?.[0]
      : undefined;
    requestFilters.date_to = Array.isArray(cleanedFilters.date)
      ? cleanedFilters.date?.[1]
      : undefined;
  }

  const organizationIds = processFilterValue(
    cleanedFilters.organisation_ids ?? cleanedFilters.organisation
  );
  if (organizationIds) {
    requestFilters.organisation_ids = organizationIds;
  }

  const counterpartyIds = processFilterValue(
    cleanedFilters.counterparty_ids ?? cleanedFilters.counterparty
  );
  if (counterpartyIds) {
    requestFilters.counterparty_ids = counterpartyIds;
  }

  if (cleanedFilters.status) {
    requestFilters.status = cleanedFilters.status;
  }


  return { cleanedFilters, requestFilters };
};
